import { seeProjectPrice } from '@ab-core-functions/user-permission';
import { useProductsAvailabilitiesWithChannel } from '@ab-core/hooks-v2';
import getActiveCart from '@ab-core/hooks/cartNew/activeCart/useActiveCart';
import type { MappedSearchResultDocument } from '@ab-core/hooks/search/mappers/productSearchMapper';
import type { DefaultScalableProductCardProps } from '../cardLayout';
import { fallBackPosition, fallBackQuantityUnit, fallBackSalesUnit } from './fallBackStates';

export const mappedOfferItemToScalableProduct = (
    product: MappedSearchResultDocument
): DefaultScalableProductCardProps['product'] => {
    const { activeCart } = getActiveCart();
    let projectNumber =
        activeCart?.custom.customFieldsRaw.find((element) => element.name === 'cart-projectNr')?.value || '0';
    const canSeeProjectPrice = seeProjectPrice();
    projectNumber = canSeeProjectPrice ? projectNumber : '0';
    const { productsAvailabilitiesWithChannel } = useProductsAvailabilitiesWithChannel({
        skus: [product.sku],
        cartId: activeCart?.id
    });

    return {
        defaultQuantity: product.quantity || product.salesUnit || fallBackSalesUnit,
        externalProductPrice: product?.priceObject || undefined,
        defaultPositionText: product.positionText || '',
        sku: product.sku,
        information: { reach: product?.reach || false },
        tags: {
            product: {
                isAbakus: product.isAbakus,
                isAbakusPlus: product.isAbakusPlus,
                topProduct: product.topProduct,
                isTecselect: product.isTecselect,
                isPromotion: product.promoProduct
            }
        },
        ids: {
            articleNumber: product.sku,
            ean: product.ean
        },
        image: { imgSrc: product.image || '', sku: product.sku },
        name: { text: product.productName, sku: product.sku },
        additionalLinks: {
            sku: product.sku,
            hasAccessories: product.hasAccessories,
            hasAlternatives: product.hasAlternatives
        },
        prices: {
            quantityUnit: product.quantityUnit || fallBackQuantityUnit,
            salesUnit: product.salesUnit || fallBackSalesUnit
        },
        availability: {
            availability: productsAvailabilitiesWithChannel?.find((available) => available.sku === product.sku),
            quantityUnit: product.quantityUnit || fallBackQuantityUnit
        },
        order: {
            packagingSize: product?.packagingSize || '',
            quantityUnit: product.quantityUnit || fallBackQuantityUnit,
            salesUnit: product.salesUnit || fallBackSalesUnit,
            sku: product.sku,
            isUnqualifiedContractProduct: product.isUnqualifiedContractProduct,
            position: product.position || fallBackPosition,
            cartId: activeCart?.id,
            hidePrice: product?.hidePrice,
            isPackageItem: product?.isPackageItem,
            projectNumber
        }
    };
};
